// グラフタイプ選択用カードUIコンポーネント

import { getGraphTypeIcon } from './GraphTypeIcons';
import * as styles from '../../styles/components/graph-builder.css';

interface GraphType {
  value: string;
  label: string;
  description?: string;
}

interface GraphTypeSelectorProps {
  graphTypes: GraphType[];
  selectedType?: string;
  onSelect: (type: string) => void;
}

export function GraphTypeSelector({
  graphTypes,
  selectedType,
  onSelect
}: GraphTypeSelectorProps) {
  return (
    <div className={styles.graphTypeSelector}>
      <label className={styles.graphTypeSelectorLabel}>Graph Type</label>
      <div className={styles.graphTypeGrid}>
        {graphTypes.map(type => {
          const isSelected = selectedType === type.value;
          return (
            <button
              key={type.value}
              className={`${styles.graphTypeCard} ${
                isSelected ? styles.graphTypeCardSelected : ''
              }`}
              onClick={() => onSelect(type.value)}
              type="button"
              title={type.description} // ツールチップとして表示
            >
              <div className={styles.graphTypeIcon}>
                {getGraphTypeIcon(type.value, 32, isSelected ? '#4285f4' : '#6c757d')}
              </div>
              <div className={styles.graphTypeLabel}>{type.label}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
